import {
  CXConfiguration,
  getComponentFromLocation,
  getParameterFromURL,
  ProjectConfig,
  getCookie
} from '@adtelligence/vue-integration-library'

const epcAnalyticsLocation = process.env.VUE_APP_EPC_ANALYTICS_LOCATION
const service = process.env.VUE_APP_SERVICE
const isConsentRequired = true

export const cxConfiguration = new CXConfiguration({
  appParentElementSelector: 'header',
  isConsentRequired,
  isConsentGivenOrNotRequired() {
    if (getParameterFromURL('tracking') === 'false') {
      return false
    }
    const optanonConsent = getCookie('OptanonConsent')
    const consentGroups = new URLSearchParams(optanonConsent)?.get('groups')?.split(',')
    if (typeof consentGroups === 'object' && consentGroups.length) {
      // no consent: ['C0001:1', 'C0002:0', 'C0003:0', 'C0004:0']
      // consent: ['C0001:1', 'C0002:1', 'C0003:0', 'C0004:0']
      return consentGroups.indexOf('C0002:1') > -1
    }
    return !isConsentRequired
  },
  companyId: 2,
  pageId: 1,
  service,
  epcAnalyticsLocation,
  hideOnStartTimeout: 10000,
  analyticsSiteId: 2,
  enableSecureCookies: true,
  nonAnalyticsCookies: [
    { partialCookieName: 'adt_opt_out', topDomain: true },
    { partialCookieName: '_adt_delivery', topDomain: true },
    { partialCookieName: 'adt_firstvisit', topDomain: false },
    { partialCookieName: 'adt_recurring', topDomain: false }
  ]
})

const projectConfigFound = getComponentFromLocation([
  {
    projectId: 3,
    pathnames: ['/cc-onboarding/'],
    strict: false,
    projectParameters: new URLSearchParams('adt=tracking'),
    getElementsToHide: null,
    hideOnStart: false
  },
  {
    projectId: 4,
    pathnames: ['/tntlandingpages/classic'],
    strict: false,
    projectParameters: new URLSearchParams('adt=lp_rebrush'),
    getElementsToHide: componentKey => {
      switch (componentKey) {
        case 102:
        case 103:
          return document.querySelectorAll('main')
        case 104:
        case 105:
          return document.querySelectorAll('main > *:not(.shape-text, .accordion)')
        default:
          return []
      }
    },
    hideOnStart: true
  }
])

export const projectConfig = projectConfigFound ? new ProjectConfig(projectConfigFound) : null
